/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';

import brandThemes from '../../../app/components/AppShell/brandtheme';
import { getFeatureFlags, getBrandConfig } from '../MfeCheckout/ducks/App/App-Selectors';
import { getOrderItemErrors } from '../Checkout/ducks/Common/ducks/Error/Error-Selector';
import { getRecipientsExcludePassport } from '../MfeCheckout/ducks/Cart/Cart-Selectors';

export const getCurrentBrandId = (state) => ({ ...{ ...state }.ui }.brandId) || '';

// Add to cart
export const getAddToCartLoaderStatus = (state) => state.addToCart.loader;
export const getAddToCartError = (state) => state.addToCart.error;

/**
 * @param {} state
 */
export const getBrandsById = (state) => {
    if (state && state.page && state.page.brands && state.page.brands.byId) {
        return state.page.brands.byId;
    }

    return null;
};
const countNoOfOrderItems = (cartItems) => {
    let noOfItems = 0;
    Object.keys(cartItems).forEach((index) => {
        noOfItems += cartItems[index].cartItems.length;
    });
    return noOfItems;
};

export const getNoOfOrderItems = (state) => {
    const cartItems = getRecipientsExcludePassport(state);
    if (cartItems && cartItems.length > 0) {
        return countNoOfOrderItems(cartItems);
    }
    return 0;
};

// Brand (Client Id)
/*
export const getBrand = createSelector(
    [
        getCurrentBrandId,
        getBrandsById,
    ],
    (currentBrandId, brandsById) => {
        if (currentBrandId && brandsById[currentBrandId]) {
            return brandsById[currentBrandId];
        }

        return null;
    },
);
*/

export const getBrand = (state) => {
    const brandConfig = getBrandConfig(state);
    return brandConfig;
};

/**
 * @param {} state
 */
export const getConfigByDomain = (state) => {
    if (state && state.app && state.app.config && state.app.config.byDomain) {
        return state.app.config.byDomain;
    }
    return null;
};

/**
 * @param {} state
 */
// Flags
/*
export const getFlags = createSelector(
    [
        getBrand,
        getConfigByDomain,
    ],
    (brand, config) => {
        if (brand && brand.domain && config) {
            return config[brand.domain]['app-feature-flags'];
        }
        return {};
    },
);
*/
export const getFlags = (state) => {
    const flags = getFeatureFlags(state);
    return flags;
};

export const getLoaderStatus = (state) => state.common.showLoadingMessage.flag;
export const getLoaderId = (state) => state.common.showLoadingMessage.loaderId;

export const getOrder = (state) => state?.order;
export const getOrderId = (state) => state?.order?.orderId || '';
export const getTotalItemInCart = (state) => state?.order?.cartCount;

// Error
export const getError = (state) => state?.common?.error;
export const getPaymentError = (state) => state?.common?.error?.payment || {};
export const getCartError = (state) => state?.common?.error?.cart || '';
export const getCart = (state) => state?.common?.error?.cart || '';
export const getRecipientFormError = (state) => state?.common?.error?.recipientForm;
export const getRecipientGiftMessageError = (state) => state?.common?.error?.giftMessage;
export const getGiftCardError = (state) => state?.common?.error?.giftCard;
export const getPromotionError = (state) => state?.common?.error?.promotion;
export const getCalendarError = (state) => state?.common?.error?.calendar;
export const getDTWError = (state) => state?.common?.error?.dtw;
export const getPayPalError = (state) => state?.common?.error?.paypal;

export const getIsPromotionHasError = (state) => {
    const promoError = getPromotionError(state);
    if (promoError?.error || promoError?.promotionCode) {
        return true;
    }
    return false;
};

export const getIsPaymentHasError = (state) => {
    const paymentError = getPaymentError(state);
    let errorMessage = '';
    Object.keys(paymentError).forEach((fieldName) => {
        if (paymentError[fieldName] !== '' && fieldName !== 'validateBillingAddress' && fieldName !== 'error') {
            errorMessage += `${paymentError[fieldName]} `;
        }
    });

    if (errorMessage !== '') {
        return true;
    }

    return false;
};

export const getIsRecipientHasError = (state) => {
    const recipientError = getOrderItemErrors(state);
    let errorMessage = '';

    Object.keys(recipientError).forEach((orderItemId) => {
        Object.keys(recipientError[orderItemId]).forEach((featureType) => {
            if (recipientError[orderItemId][featureType].errorKey) {
                errorMessage += `${recipientError[orderItemId][featureType].errorKey} `;
            }
        });
    });

    if (errorMessage !== '') {
        return true;
    }

    return false;
};

// Recipients
export const getRecipientForm = (state) => state?.recipient?.recipientForm;
export const getCurrentRecipients = (state) => state?.recipient?.recipients;
export const getWorkingRecipient = (state) => state?.recipient?.workingRecipient;
export const getShippingInfo = (state) => state?.recipient?.shippingInfo;
export const getGiftMessageInfo = (state) => state?.recipient?.giftMessage;
export const getUserSubmittedProductFilterZipcode = (state) => state.ui.appContext.userSubmittedProductFilterZipcode;

export const getIfZipCodeIsValid = (state) => {
    const recipientFormError = getRecipientFormError(state);
    // avoid international product - zipcode is saved as 00000
    if (recipientFormError?.zipCode !== '00000' && recipientFormError?.zipCode === 'Invalid Zip Code') {
        return false;
    }
    return true;
};

// QAS Address Search
export const getQasSearchSuggestion = (state) => state.common.addressSearchQAS.suggestion;
export const getQasSearchFormattedAddress = (state) => state.common.addressSearchQAS.formattedAddress;
export const getShowValidatedAddressSuggestion = (state) => state.common.addressSearchQAS.showValidatedAddressSuggestion;
export const getHasQasFailed = (state) => state.common.addressSearchQAS.qasFailed;

// Gift Expressions
export const getGiftMessageExpressions = (state) => state.recipient.giftMessageExpressions;

// Payment
export const getPaymentDetails = (state) => state?.checkout?.payment?.paymentDetails;
export const getRewardPointsInfo = (state) => state?.checkout?.payment?.rewardPoints;
export const getPaymentInfo = (state) => state?.checkout?.payment?.paymentForm;
export const getPaymentMethod = (state) => state?.checkout?.payment?.paymentForm?.paymentMethod;
export const getPaymentMethods = (state) => state?.checkout?.payment?.paymentMethods;
export const getApplePayStatus = (state) => state?.checkout?.payment?.paymentMethods?.ApplePay?.active;

export const getIfPayPalPaymentFailedDueToMissingAddress = createSelector(
    [
        getPaymentError,
    ],
    (paymentFailedError) => {
        if (paymentFailedError.error === 'ERROR_PAYPAL_ADDRESS') {
            return true;
        }
        return false;
    },
);

// Subscription
export const getSubscription = (state) => state?.checkout?.payment?.subscription;
export const getEmailOptIn = (state) => state?.checkout?.payment?.subscription?.emailOptIn;
export const getSMSOptIn = (state) => state?.checkout?.payment?.subscription?.smsOptIn;
export const getOptInEntryMessage = (state) => state?.checkout?.payment?.subscription?.optInEntryMessage;
export const getUserProfile = (state) => state?.account?.userProfile;

// promotion
export const getPromotionDetails = (state) => state.checkout.payment.promotion;

export const removeMaskForPhoneNumber = (number) => {
    let strNumber = number.toString().trim();
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

// Get Order Item By Order Id
export const getOrderItemById = (orderItemList, cartItemId) => {
    const filterOrderItem = [];
    if (orderItemList.length > 0) {
        orderItemList.forEach((items) => {
            items.cartItems.forEach((cartItem) => {
                if (cartItem.cartItemId === cartItemId) {
                    const { recipientAddress } = items;
                    filterOrderItem[0] = {
                        cartItem: [cartItem],
                        recipientAddress,
                    };
                }
            });
        });
    }
    return filterOrderItem;
};

export const getOrderItemsWithError = (state) => {
    const paymentErrors = getPaymentError(state);
    return Object.keys(paymentErrors).filter((errorKey) => (Number(errorKey) > 0 && Number(errorKey) > 0 && paymentErrors[errorKey]));
};

// Passport
export const getPaymentMethodToPurchasePassport = () => ['CreditCard', 'PayPal'];

/**
 * @param {} state
 */
// Brand Customer Care Contact
export const getCustomerCare = (state) => {
    const brandDetails = getBrand(state);
    if (brandDetails && brandDetails.phoneNumber) {
        return brandDetails.phoneNumber;
    }
    return '';
};

/**
 * @param {} state
 */
// Get Passport Feature Flag
export const getFlagEnablePassport = (state) => {
    const flags = getFlags(state);
    if (flags && Object.prototype.hasOwnProperty.call(flags, 'is-product-passport-banner-enabled')) {
        return flags['is-product-passport-banner-enabled'];
    }
    return false;
};

/**
 * @param {} state
 */
// Get Espot
export const getEspotById = (state, id) => {
    if (state && state.entities && state.entities.espots) {
        let espot = state.entities.espots.byId[id];
        if (!espot) {
            const arrEspotName = Object.keys(state.entities.espots.byId).filter(((espotId) => (espotId.indexOf(id) >= 0)));
            const [espotName] = arrEspotName;
            espot = state.entities.espots.byId[espotName] || null;
        }
        return espot;
    }
    return null;
};

export const getCdnImagePath = (state) => {
    const brandDetails = getBrand(state) || '';
    return `https://cdn1.${brandDetails['domain-name']}.com/wcsstore/${brandDetails.identifier}/images`;
};

export const getProductsById = function getProductsById(state) {
    if (state && state.catalog && state.catalog.products && state.catalog.products.byId) {
        return state.catalog.products.byId;
    }
    return null;
};

export const getSelectedProductSku = function getSelectedProductSku(state) {
    if (state && state.ui && state.ui.pdpCart && state.ui.pdpCart.selectedSKUProduct) {
        return state.ui.pdpCart.selectedSKUProduct;
    }
    return null;
};

// DTW - selectors
export const getDTWOptions = (state) => {
    if (state && state.common && state.common.dtw) {
        return state.common.dtw;
    }

    return null;
};

export const isCheckoutPage = () => {
    if (typeof window !== 'undefined') {
        if (window.location.pathname.indexOf('/checkout') >= 0 || window.location.pathname.indexOf('/add-ons') >= 0) {
            return true;
        }
    }
    return false;
};

export const getLogo = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { logos } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return logos?.primary_logo?.url;
        }
        return null;
    },
);

export const getGiftMessageConfiguration = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { giftMessageConfig } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return giftMessageConfig;
        }

        return {};
    },
);

// Checkout Food Supported Payment Method
export const getSupportedPaymentMethods = createSelector(
    [getFlags, getApplePayStatus],
    (flags, applePayStatus) => {
        const paymentMethods = ['CreditCard'];

        // Paypal Enabled
        if (flags['is-paypal-braintree-enabled']) {
            paymentMethods.push('PayPal');
        }

        // Chase Pay Enabled
        if (flags['is-chasepay-enabled']) {
            paymentMethods.push('ChasePay');
        }

        // Apple Pay Enabled
        if (flags['is-apple-pay-enabled-checkout'] && applePayStatus === 1) {
            paymentMethods.push('ApplePay');
        }

        return paymentMethods;
    },
);

// Pmall Personalization
export const getPmallSummaryInfo = (state) => state.common.pmallPersonalization || {};

// Passport Bundle
export const getPassportBundleData = (state) => state?.passport?.passportBundle;

export const getPassportBundleCollectionData = (state) => state?.passport?.passportBundleCollection;

// Passport Campaign Data
export const getPassportCampaignData = (state) => state?.passport?.passportCampaign;

export const getPassportSignInData = (state) => state?.passport?.passportSignIn;

// Passport Side Bar Status
export const getPassportSideBarStatus = (state) => state?.passport?.passportSideBarStatus;

export const getPassportData = (state) => state?.passport?.passportData;

export const getPassportTncContentMarkUp = (state) => state?.passport?.tncContent;

export const getPassportBannerStatus = (state) => {
    const paymentMethod = getPaymentMethod(state);
    const allowedPaymentMethods = getPaymentMethodToPurchasePassport();
    if (allowedPaymentMethods.includes(paymentMethod?.id)) {
        return true;
    }
    return false;
};

export const getStatusOfPassportApplyRmGC = (state) => state?.passport?.showPassportConsentToRmGC;

export const getPassportProcessStatus = (state) => state?.passport?.passportProcess;

export const dynamicPassportCharge = (state) => state?.mfeCheckout?.passport?.dynamicPassportCharge;

export const getPassportError = (state) => state?.passport?.error;

export const getPassportLoader = (state) => state?.passport?.loader;

export const getPassportABData = (state) => state?.passport?.passportABData;
